<template>
  <div class="pa-4">
    <v-row>
      <v-col cols="6">
        <v-select label="View mode" :items="filters" v-model="filterMode">
        </v-select>
      </v-col>
      <v-col cols="6">
        <v-range-slider
          v-model="priorityRange"
          label="Priority"
          step="1"
          min="0"
          max="3"
          width="200"
        ></v-range-slider
      ></v-col>

      <v-col cols="2">
        <v-switch
          v-model="cards"
          label="Cards"
          color="amber"
          class="mr-3 ml-3"
          inset
        ></v-switch
      ></v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-expansion-panels v-model="panels" light class="" multiple>
          <v-expansion-panel
            v-for="(row, index) in returnParentList()"
            :key="`panel-${index}`"
          >
            <v-expansion-panel-header
              ><h2 class="text-h6">{{ row }}</h2></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <v-row>
                <template v-for="el in returnRelatedCategories(row)">
                  <v-col v-if="cards" cols="3" :key="`card-${el.id}`">
                    <v-card height="100%">
                      <v-card-text>
                        <ChallengeCard
                          :el="el"
                          :attrs="attrs"
                          :local="doc.local"
                        />
                      </v-card-text>
                      <v-card-actions>
                        <v-btn x-small @click="copyItem(el)">Copy</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col
                    v-if="cards == false"
                    cols="12"
                    :key="`table-${el.id}`"
                  >
                    <ChallengeRow
                      :el="el"
                      :attrs="attrs"
                      :local="doc.local"
                      @edit="editItem"
                      @copy="copyItem"
                      @delete="deleteItem"
                    />
                  </v-col>
                </template>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        Not solveable by Brand Architecture
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col v-for="item in returnDisabledItems()" :key="item.id" cols="3">
            <v-card light>
              <v-card-text>
                <ChallengeCard :el="item" :attrs="attrs" :local="doc.local" />
              </v-card-text>
              <v-card-actions>
                <v-btn x-small @click="editItem(item)">Edit</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card light v-if="dialogMode == 'add'">
        <v-card-title class="headline">Adding item</v-card-title>
        <v-card-text>
          <ItemForm
            :key="`${activeItem.id}-${editKey}`"
            :new-item="activeItem"
            :colors="colors"
            :local="local"
            @submit="commitSave"
            @cancel="closeDialog"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card light v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Editing item</v-card-title>
        <v-card-text>
          <ItemForm
            :key="`${activeItem.id}-${editKey}`"
            :new-item="activeItem"
            :colors="colors"
            :local="local"
            @submit="commitEdit"
            @cancel="closeDialog"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card light v-if="dialogMode == 'delete'">
        <v-card-title class="headline"
          >Are you sure you want to delete this item?</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="commitDelete">
            Confirm
          </v-btn>
          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ChallengeCard from "@/views/user/exercises/challenges-system/ChallengeCard";
import ChallengeRow from "@/views/user/exercises/challenges-system/ChallengeRow";
import ChallengesMixin from "@/views/user/exercises/challenges-system/ChallengesMixin";
import ItemForm from "@/views/user/exercises/challenges-system/ItemForm";
import lodash from "lodash";

export default {
  name: "ChallengesView",
  mixins: [ChallengesMixin],
  components: {
    ChallengeCard,
    ChallengeRow,
    ItemForm,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    doc: {
      type: Object,
      default: () => {},
    },
    attrs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      filterMode: "category",
      filters: ["themes", "category", "tags"],
      priorityRange: [0, 3],
      details: true,
      cards: false,
      compact: false,
      panels: [],
    };
  },
  methods: {
    returnParentList() {
      switch (this.filterMode) {
        case "category":
          return this.doc.local.categories;
        case "themes":
          return this.doc.local.themes;
        case "tags":
          return this.doc.local.tags;
        default:
          return [];
      }
    },
    returnDisabledItems() {
      return this.items.filter((x) => x.disabled);
    },
    returnOrderedList(arr) {
      const rangeArr = arr.filter(
        (x) =>
          x.priority >= this.priorityRange[0] &&
          x.priority <= this.priorityRange[1] &&
          x.disabled != true
      );
      return lodash.orderBy(rangeArr, "priority", "desc");
    },
    returnRelatedCategories(filter) {
      console.log("filter", filter);
      let filterArr = this.items.filter((x) => x.disabled != true);
      if (this.filterMode === "category") {
        filterArr = this.items.filter((x) => x.categories.includes(filter));
      }
      if (this.filterMode === "tags") {
        filterArr = this.items.filter((x) => x.tags.includes(filter));
      }
      if (this.filterMode === "themes") {
        filterArr = this.items.filter((x) => x.themes.includes(filter));
      }
      const rangeArr = filterArr.filter(
        (x) =>
          x.priority >= this.priorityRange[0] &&
          x.priority <= this.priorityRange[1] &&
          x.disabled != true
      );
      return lodash.orderBy(rangeArr, "priority", "desc");
    },
  },
  computed: {
    panel() {
      // return Array(this.returnParentList().length).fill(1);
      return [1, 1, 1, 1, 1, 1, 1, 1];
    },
    filteredResults() {
      return this.filterMode === "category"
        ? this.groupedByCategory
        : this.groupedByTheme;
    },
    groupedByCategory() {
      var arr = lodash.groupBy(this.items, "categories");
      return arr;
    },
    groupedByTheme() {
      var arr = lodash.groupBy(this.items, "themes");
      return arr;
    },
  },
};
</script>
